import React from "react";

const RegisterationClosed = () => {
	return (
		<div className="registerationclosed">
			<div className="card">Registration is Closed</div>
		</div>
	);
};

export default RegisterationClosed;
